import React from 'react';
import { LayoutCards } from '@saleshandy/icons';

const ColumnFilter = () => (
  <LayoutCards className='blue-txt-11' />
);

export default ColumnFilter;
